import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Loadercomponent from "../../../../Componets/Loader";
import { Modal, Form, Input, Select, DatePicker, Button, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import {
  add_customer_balance,
  get_customer_balance_summary,
  get_customer_balance_logs
} from "../../../../Controllers/Customers/Balance";
import { get_customer } from "../../../../Controllers/Customers";
import { get_all_invoices } from "../../../../Controllers/Sales/Invoices";

import headers from "../../../../Data/Tables/Customers/Balances/headers";


import {
  handleDateKeyDown,
  handleDateInput,
  handleDateBlur,
  blockPaste,
} from "../../../../Componets/Formcomponents/dateUtility";
import dayjs from "dayjs";
import formatDateDDMMYYYY from "../../../../Main/formatDate";

const { Option } = Select;
const { TextArea } = Input;

const CustomerBalanceManagement = () => {

  const [totals, setTotals] = useState({ delivery_date: new Date() });
  const dateFormatList = ["DD/MM/YYYY"];

  const handleDeliveryDate = (data) => {
    setTotals((prev) => ({
      ...prev,
      delivery_date: data.$d || data,
    }));
  };
  const id = localStorage.getItem("Customer_Id");

  const [form] = Form.useForm();
  const [invoiceForm] = Form.useForm();

  const [loader, setLoader] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isInvoiceModalVisible, setIsInvoiceModalVisible] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [summary, setSummary] = useState({});
  const [outstandingInvoices, setOutstandingInvoices] = useState([]);
  const [paymentAmounts, setPaymentAmounts] = useState({});
  const [loading, setLoading] = useState(false);
  const [header, setHeader] = useState(headers);

  const paymentOptions = [
    { value: "Cash", label: "Cash" },
    { value: "Debit card", label: "Debit card" },
    { value: "Bank transfer", label: "Bank transfer" },
    { value: "Credit card", label: "Credit card" },
    { value: "Cheque", label: "Cheque" },
    { value: "Online payment", label: "Online payment" },
  ];

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    if (id) {
      fetchCustomerData();
      fetchBalanceSummary();
      fetchOutstandingInvoices();
      headerReset();
    }
  }, [id]);

  const fetchCustomerData = async () => {
    try {
      const response = await get_customer({ id });
      const responsessss = await get_customer_balance_logs({ customer: id });

      if (response?.status) {
        setCustomer(response.data);
      }
    } catch (error) {
      message.error("Failed to fetch customer data");
    }
  };

  const fetchBalanceSummary = async () => {
    try {
      const response = await get_customer_balance_summary({ customer: id });
      if (response.success || response?.status) {
        setSummary(response.data);
      }
    } catch (error) {
      message.error("Failed to fetch balance summary");
    }
  };

  const calculateOutstanding = (invoice) => {
    const total = invoice.total || 0;
    const paid =
      invoice.payments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;
    return total - paid;
  };

  const fetchOutstandingInvoices = async (filters = {}) => {
    setLoader(true);
    try {
      const params = {
        customer: id,
        limit: 100,
        search: filters?.search,
        payment: filters?.payment_status,
        date: filters?.date,
      };

      const response = await get_all_invoices(params);

      if (response?.status) {
        const allInvoices = response?.data?.data || [];

        const outstanding = allInvoices
          .filter((inv) => calculateOutstanding(inv) > 0)
          .map((invoice) => ({
            ...invoice,
            outstanding: calculateOutstanding(invoice),
          }));

        setOutstandingInvoices(outstanding);

        setPaymentAmounts({});
      } else {
        message.error("Failed to fetch invoices");
      }
    } catch (error) {
      message.error("Failed to fetch outstanding invoices");
    } finally {
      setLoader(false);
    }
  };

  const handleFormData = (data) => {
    fetchOutstandingInvoices(data);
  };

  const handleAddBalance = async (values) => {
    setLoading(true);
    try {
      const payload = {
        customer: id,
        type: values.type,
        amount: parseFloat(values.amount),
        description: values.description,
        payment_method: values.payment_method,
        payment_date: values.payment_date
          ? values.payment_date.toDate()
          : new Date(),
        reference_type: "manual",
        reference_number: values.reference_number,
      };

      const response = await add_customer_balance(payload);

      if (response.success || response?.status) {
        message.success("Balance added successfully");
        setIsModalVisible(false);
        form.resetFields();
        fetchBalanceSummary();
        fetchOutstandingInvoices();
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Failed to add balance");
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentAmountChange = (invoiceId, amount) => {
    setPaymentAmounts((prev) => ({
      ...prev,
      [invoiceId]: amount,
    }));
  };

  const handleClearBalances = async (values) => {
    setLoading(true);
    try {
      const totalPaymentAmount = Object.values(paymentAmounts).reduce(
        (sum, amount) => sum + (parseFloat(amount) || 0),
        0
      );

      const currentBalance = summary.current_balance || 0;
      if (totalPaymentAmount > currentBalance) {
        message.error(
          `Total payment amount (OMR ${totalPaymentAmount.toFixed(
            3
          )}) exceeds current balance (OMR ${currentBalance.toFixed(3)})`
        );
        setLoading(false);
        return;
      }

      if (totalPaymentAmount <= 0) {
        message.error("Please enter valid payment amounts");
        setLoading(false);
        return;
      }

      const invoicesPayload = Object.entries(paymentAmounts)
        .filter(([_, amount]) => amount > 0)
        .map(([invoiceId, amount]) => ({
          invoice_id: invoiceId,
          amount: parseFloat(amount),
        }));

      if (invoicesPayload.length === 0) {
        message.error("No valid payment amounts entered");
        setLoading(false);
        return;
      }

      const payload = {
        customer: id,
        type: "payment",
        amount: parseFloat(totalPaymentAmount),
        description: values.description || "Invoice payment",
        payment_method: values.payment_method,
        payment_date: values.payment_date
          ? values.payment_date.toDate()
          : new Date(),
        reference_type: "payment",
        reference_number: values.reference_number,
        invoices: invoicesPayload,
      };

      const response = await add_customer_balance(payload);


      if (response.success || response?.status) {
        message.success("Payment processed successfully");
        setIsInvoiceModalVisible(false);
        invoiceForm.resetFields();
        setPaymentAmounts({});
        fetchBalanceSummary();
        fetchOutstandingInvoices();
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Failed to process payment");
    } finally {
      setLoading(false);
    }
  };

  const invoiceColumns = [
    {
      title: "Invoice No",
      dataIndex: "number",
      render: (text) => `#${text}`,
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => formatDateDDMMYYYY(date),
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      render: (date) => (date ? formatDateDDMMYYYY(date) : "–"),
    },

    {
      title: "Total Amount",
      dataIndex: "total",
      render: (amount) => `OMR ${amount?.toFixed(3)}`,
    },
    {
      title: "Paid Amount",
      dataIndex: "paid_amount",
      render: (_, record) => {
        const paid =
          record.payments?.reduce((sum, p) => sum + (p.amount || 0), 0) || 0;
        return `OMR ${paid.toFixed(3)}`;
      },
    },
    {
      title: "Outstanding",
      dataIndex: "outstanding",
      render: (outstanding) => `OMR ${outstanding?.toFixed(3)}`,
    },
    {
      title: "Payment Amount",
      dataIndex: "payment_amount",
      render: (_, record) => (
        <Input
          type="number"
          placeholder="0.000"
          min="0"
          max={record.outstanding}
          step="0.001"
          value={paymentAmounts[record._id] || ""}
          onChange={(e) => {
            const value = parseFloat(e.target.value) || 0;
            handlePaymentAmountChange(record._id, value);
          }}
          onKeyDown={(e) => {
            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
              e.preventDefault();
            }
          }}
          onWheel={(e) => {
            e.target.blur();
          }}
          onBlur={(e) => {
            const value = parseFloat(e.target.value) || 0;
            const outstanding = record.outstanding;
            if (value > outstanding) {
              handlePaymentAmountChange(record._id, outstanding);
              message.warning(
                `Payment amount cannot exceed outstanding amount (OMR ${outstanding.toFixed(
                  3
                )})`
              );
            }
          }}
        />
      ),
    },
  ];

  const getTotalPaymentAmount = () => {
    return Object.values(paymentAmounts).reduce(
      (sum, amount) => sum + (parseFloat(amount) || 0),
      0
    );
  };

  const getCurrentBalance = () => {
    return summary.current_balance || 0;
  };

  const isPaymentValid = () => {
    const totalPayment = getTotalPaymentAmount();
    const currentBalance = getCurrentBalance();
    return totalPayment > 0 && totalPayment <= currentBalance;
  };

  return (
    <div>
      <Header headers={header} setHeaders={setHeader} formdata={handleFormData}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 mt-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className="text-gray-700 mb-2">Current Balance</h3>
            <p
              className={` ${(summary.current_balance || 0) >= 0
                ? "text-green-600"
                : "text-red-600"
                }`}
            >
              OMR {summary.current_balance?.toFixed(3) || "0.000"}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className="text-gray-700 mb-2">Total Outstanding</h3>
            <p className=" text-red-600">
              OMR {summary.total_outstanding?.toFixed(3) || "0.000"}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className="text-gray-700 mb-2">Overdue Amount</h3>
            <p className=" text-orange-600">
              OMR {summary.overdue_amount?.toFixed(3) || "0.000"}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className="text-gray-700 mb-2">Available Balance</h3>
            <p
              className={` ${(summary.available_balance || 0) >= 0
                ? "text-blue-600"
                : "text-red-600"
                }`}
            >
              OMR {summary.available_balance?.toFixed(3) || "0.000"}
            </p>
          </div>
        </div>

        <div className="flex gap-4 mb-6">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setIsModalVisible(true)}
          >
            Add Balance
          </Button>
          <Button
            type="default"
            onClick={() => setIsInvoiceModalVisible(true)}
            disabled={summary.total_outstanding <= 0}
          >
            Clear Outstanding Balances
          </Button>
        </div>

        <Loadercomponent loader={loader}>
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-4 border-b">
              <h3 className="text-lg font-semibold">Outstanding Invoices</h3>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-50">
                    {invoiceColumns.map((column, index) => (
                      <th
                        key={index}
                        className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        {column.title}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {outstandingInvoices.map((invoice) => (
                    <tr key={invoice._id}>
                      {invoiceColumns.map((column, colIndex) => (
                        <td
                          key={colIndex}
                          className="px-4 py-3 whitespace-nowrap text-sm text-gray-900"
                        >
                          {column.render
                            ? column.render(invoice[column.dataIndex], invoice)
                            : invoice[column.dataIndex]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Loadercomponent>
      </Header>

      <Modal
        title="Add Customer Balance"
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          form.resetFields();
        }}
        onOk={() => form.submit()}
        confirmLoading={loading}
      >
        <Form form={form} layout="vertical" onFinish={handleAddBalance}>
          <Form.Item
            name="type"
            label="Transaction Type"
            initialValue="deposit"
            rules={[{ required: true, message: "Please select type" }]}
          >
            <Select disabled>
              <Option value="deposit">Deposit</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="amount"
            label="Amount"
            rules={[{ required: true, message: "Please enter amount" }]}
          >
            <Input type="number" step="0.001" placeholder="0.000" onKeyDown={(e) => {
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                e.preventDefault();
              }
            }}
              onWheel={(e) => {
                e.target.blur();
              }} />
          </Form.Item>

          <Form.Item
            name="payment_method"
            label="Payment Method"
            rules={[
              { required: true, message: "Please select payment method" },
            ]}
          >
            <Select>
              {paymentOptions.map((option) => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="reference_number" label="Reference Number">
            <Input placeholder="Enter reference number" />
          </Form.Item>

          <Form.Item
            name="payment_date"
            label="Payment Date"
            initialValue={dayjs()}
          >
            <DatePicker
              format={dateFormatList}
              className="w-full"
              placeholder="Select date"
              value={dayjs(form.getFieldValue("payment_date") || new Date())}
              onChange={(date) => form.setFieldsValue({ payment_date: dayjs(date) })}
              autoComplete="off"
              onKeyDown={handleDateKeyDown}
              onInput={handleDateInput}
              onPaste={blockPaste}
              onBlur={(e) =>
                handleDateBlur(e, (date) =>
                  form.setFieldsValue({ payment_date: dayjs(date) })
                )
              }
            />
          </Form.Item>


          <Form.Item name="description" label="Description">
            <TextArea rows={3} placeholder="Enter description" />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Clear Outstanding Balances"
        open={isInvoiceModalVisible}
        onCancel={() => {
          setIsInvoiceModalVisible(false);
          invoiceForm.resetFields();
          setPaymentAmounts({});
          setTotals({ delivery_date: new Date() });
        }}
        onOk={() => invoiceForm.submit()}
        confirmLoading={loading}
        width={800}
        okButtonProps={{ disabled: !isPaymentValid() }}
      >
        <Form
          form={invoiceForm}
          layout="vertical"
          onFinish={handleClearBalances}
        >
          <Form.Item
            name="payment_method"
            label="Payment Method"
            rules={[
              { required: true, message: "Please select payment method" },
            ]}
          >
            <Select>
              {paymentOptions.map((option) => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="reference_number" label="Reference Number">
            <Input placeholder="Enter reference number" />
          </Form.Item>

          <Form.Item
            name="payment_date"
            label="Payment Date"
            initialValue={dayjs(totals.delivery_date)}
          >
            <DatePicker
              format={dateFormatList}
              className="w-full"
              placeholder="Select date"
              value={dayjs(totals.delivery_date)}
              onChange={(date) => handleDeliveryDate({ $d: date.toDate() })}
              autoComplete="off"
              onKeyDown={handleDateKeyDown}
              onInput={handleDateInput}
              onPaste={blockPaste}
              onBlur={(e) =>
                handleDateBlur(e, (date) => handleDeliveryDate({ $d: date }))
              }
            />
          </Form.Item>

          <Form.Item name="description" label="Description">
            <TextArea rows={3} placeholder="Enter payment description" />
          </Form.Item>

          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
            <div className="flex justify-between items-center mb-2">
              <h4 className="font-semibold">Payment Summary:</h4>
              <div className="text-sm">
                <span className="text-gray-600">Current Balance: </span>
                <span className="font-semibold">
                  OMR {getCurrentBalance().toFixed(3)}
                </span>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Total Payment Amount:</span>
              <span
                className={`font-semibold ${getTotalPaymentAmount() > getCurrentBalance()
                  ? "text-red-600"
                  : "text-green-600"
                  }`}
              >
                OMR {getTotalPaymentAmount().toFixed(3)}
              </span>
            </div>
            {getTotalPaymentAmount() > getCurrentBalance() && (
              <div className="text-red-600 text-sm mt-2">
                Total payment amount exceeds current balance
              </div>
            )}
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default CustomerBalanceManagement;
